/**
 * 定价
 */

import { getAccountPlan } from '@umu/umu-api';
import type { IPlanInfo, IProps, IUserInfo } from '@umu/umu-types';
import { useEffect, useState } from 'react';
import { PlanPricing } from '../@planPricingCommon/planPricing';

interface IProp {
    siteHost: string;
    userInfo: IUserInfo;
}
export function App(props: IProp) {
    const initStates = {
        userInfo: props.userInfo,
    };
    const [planInfo, setPlanInfo] = useState<IPlanInfo>({} as IPlanInfo);

    useEffect(() => {
        const loadData = async () => {
            const data = await getAccountPlan();
            setPlanInfo(data.data);
        };
        if (!initStates.userInfo.teacher_id || !initStates.userInfo.umu_id) {
            return;
        }
        loadData();
    }, [initStates.userInfo.teacher_id, initStates.userInfo.umu_id]);

    const planAllInfo: IProps = {
        isRegisterUser: true,
        siteHost: props.siteHost,
        platform: 'twww',
        planInfo,
    };
    if (!initStates.userInfo.teacher_id || !initStates.userInfo.umu_id) {
        planAllInfo.isRegisterUser = false;
    }
    return (
        <div className="plan-twww-pricing-index-page">
            <PlanPricing {...planAllInfo} userInfo={initStates.userInfo} />
        </div>
    );
}
